import Badge from './index'

interface Props {
  isActive?: boolean
}

const ActiveBadge = ({ isActive }: Props) => {
  const text = typeof isActive === 'undefined' ? '-' : isActive ? 'active_lbl' : 'inactive_lbl'
  const color = isActive ? 'green' : 'gray'
  return <Badge color={color} text={text} />
}

export default ActiveBadge
